define('lib/multivariate-testing/test-configs/BaseTestConfig',['require','exports','module'],function (require, exports, module) {
    /**
     * An abstract class for test config modules.
     * This class serves as documentation and as form of basic type checking.
     *
     * Use by instantiating this class and providing override properties:
     *
     * new BaseTestConfig({id: 'override-id', variations: [...], ...});
     */
    module.exports = function (options) {
        /**
         * {string}
         * ID of the test. Try to use this for naming, flags, and so on, for consistency.
         * id = 'example-variation'
         */
        if (typeof options.id !== 'string') {
            throw Error('Test config id is not a string.');
        }
        this.id = options.id;

        /**
         * {array}
         * List of possible variations for the test and their options.
         * variations: [
         *    {id: 'control', exampleOption: 'example'},
         *    {id: 'variation-a', exampleOption: 'example2'}
         * ]
         */
        if (!options.variations instanceof Array) {
            throw Error('Test config variations is not an array.');
        }
        this.variations = options.variations;

        /**
         * {function}
         * Checks if a user is eligible to participate in a test.
         * returns a promise. Resolves if the user is eligible, rejects if not eligible.
         */
        if (typeof options.checkEligibility !== 'function') {
            throw Error('Test config checkEligibility is not a function.');
        }
        this.checkEligibility = options.checkEligibility;

        /**
         * {function}
         * Selects a variation.
         * returns a promise resolving with that variation ID.
         *
         * Override with an allocation strategy module.
         */
        if (typeof options.allocate !== 'function') {
            throw Error('Test config allocate is not a function.');
        }
        this.allocate = options.allocate;

        /**
         * {function}
         * Saves a provided test variation for later sessions.
         * returns a promise that resolves when saving is complete.
         *
         * Override with a save strategy module.
         */
        if (typeof options.saveVariation !== 'function') {
            throw Error('Test config saveVariation is not a function.');
        }
        this.saveVariation = options.saveVariation;

        /**
         * {function}
         * Checks what variation the user has been saved with for the specified test.
         * returns a promise that resolves with the variation ID, if any.
         *
         * Override with a check strategy module.
         */
        if (typeof options.checkVariation !== 'function') {
            throw Error('Test config checkVariation is not a function.');
        }
        this.checkVariation = options.checkVariation;
    };
});

